import React from "react";

export const PostalContext = React.createContext([]);
